<template>
  <div>
    <vue-html2pdf
      :show-layout="!true"
      :float-layout="true"
      :enable-download="false"
      :preview-modal="false"
      :paginate-elements-by-height="1400"
      :filename="`Ingresso`"
      :pdf-quality="2"
      :manual-pagination="false"
      pdf-orientation="portrait"
      :pdf-content-width="settings.paperSize"
      @progress="onProgress($event)"
      @error="onError($event)"
      @beforeDownload="beforeDownload"
      ref="html2Pdf"
      :html-to-pdf-options="{
        jsPDF: {
          unit: 'mm',
          format: [
            settings.paperSize.replace('mm', ''),
            settings.paperSize.replace('mm', ''),
          ],
          orientation: 'portrait',
        },
      }"
    >
      <section class="v-application" slot="pdf-content">
        <v-theme-provider light>
          <div>
            <v-card elevation="0" :width="settings.paperSize">
              <div
                class="d-flex flex-column"
                :style="{
                  paddingTop: (settings.margins?.top || 0) + 'mm',
                  paddingBottom: (settings.margins?.bottom || 0) + 'mm',
                  paddingLeft: (settings.margins?.left || 0) + 'mm',
                  paddingRight: (settings.margins?.right || 0) + 'mm',
                }"
              >
                <v-img
                  v-if="printSettings.printPlatformLogo || true"
                  style="
                    max-width: 90%;
                    max-height: 150px;
                    filter: grayscale(100%);
                  "
                  src="/img/logo/logo-dark.png"
                />
                <h4
                  v-if="printSettings.printTitle"
                  class="text-center mb-2 lh-3"
                >
                  {{ ticket?.Party?.name }}
                </h4>
                <h5
                  v-if="printSettings.printSubTitle && ticket?.Party?.subtitle"
                  class="text-center mb-0 lh-3"
                >
                  {{ ticket?.Party?.subtitle }}
                </h5>
                <p v-if="printSettings.printDateTime" class="text-center mb-0">
                  {{ ticket?.Party?.date | date("DD/MM/YYYY [ÀS] HH:mm") }}
                </p>
                <p
                  v-if="printSettings.printLocation && ticket?.Party?.Address"
                  class="text-center mb-0 lh-3"
                >
                  {{ ticket?.Party?.Address.name }}
                </p>

                <qrcode-vue
                  v-if="printSettings.printQrCode"
                  class="d-flex justify-center pa-3 ma-2 white rounded"
                  :value="ticket?.code || ''"
                  size="160"
                  level="M"
                />

                <h6
                  v-if="printSettings.printSector"
                  class="text-center mb-0 black white--text pa-2"
                >
                  <span>{{ ticket?.ticketGroup }} </span>
                  <span v-if="printSettings?.printLot"
                    >• {{ ticket?.ticketBlock }}</span
                  >
                </h6>
                <p
                  v-if="ticket?.Payment?.paymentType === 'COURTESY'"
                  class="text-center mb-0 lh-3"
                >
                  <b>CORTESIA</b><br />
                  <span>Venda Proibida</span>
                </p>
                <template v-else>
                  <p
                    v-if="printSettings?.printTotalAmount"
                    class="text-center mb-0 lh-3"
                  >
                    Valor Total: {{ ticket?.amount | currency }}
                  </p>
                  <p
                    v-if="printSettings?.printPrice"
                    class="text-center mb-0 lh-3"
                  >
                    Valor:
                    {{ (ticket?.amount - (ticket?.clientFee || 0)) | currency }}
                  </p>
                  <p
                    v-if="printSettings?.printFee"
                    class="text-center mb-0 lh-3"
                  >
                    Taxa: {{ ticket?.clientFee | currency }}
                  </p>
                </template>
                <v-card
                  outlined
                  class="pa-1 text-12 mb-2 mt-2"
                  rounded="lg"
                  style="border: 2px solid"
                >
                  <v-row no-gutters class="mx-0 text-center">
                    <v-col cols="6" class="font-weight-bold lh-1">
                      <div class="d-flex flex-column">
                        Ingresso
                        <b class="font-weight-medium pa-0">
                          #{{ ticket?.id | shortId }}
                        </b>
                      </div>
                    </v-col>
                    <v-col cols="6" class="font-weight-bold lh-1">
                      <div class="d-flex flex-column">
                        Pagamento
                        <b class="pa-0">
                          #{{ ticket?.Payment?.id | shortId }}
                        </b>
                      </div>
                    </v-col>
                    <v-col cols="6" class="font-weight-bold pt-2 lh-1">
                      <div class="d-flex flex-column">
                        Compra
                        <b class="pa-0">
                          {{
                            ticket?.Payment?.payedAt
                              | date("DD/MM/YYYY HH[h]mm")
                          }}
                        </b>
                      </div>
                    </v-col>
                    <v-col cols="6" class="font-weight-bold pt-2 lh-1">
                      <div class="d-flex flex-column">
                        Impressão
                        <b class="pa-0">
                          {{ new Date() | date("DD/MM/YYYY HH[h]mm") }}
                        </b>
                      </div>
                    </v-col>
                    <v-col cols="6" class="font-weight-bold pt-2 lh-1">
                      <div class="d-flex flex-column">
                        Forma Pagamento
                        <b class="pa-0">
                          {{
                            this.paymentUtils.paymentType[
                              ticket?.Payment?.paymentType
                            ]?.text || ticket?.Payment?.paymentType
                          }}
                        </b>
                      </div>
                    </v-col>
                    <v-col cols="6" class="font-weight-bold pt-2 lh-1">
                      <div class="d-flex flex-column">
                        PDV
                        <b class="pa-0">
                          {{
                            ticket?.Payment?.PosSession?.name ||
                            ticket?.Payment?.PosSession?.Address?.name
                          }}
                        </b>
                      </div>
                    </v-col>
                  </v-row>
                </v-card>
                <p
                  v-if="printSettings.printFooterMessage"
                  class="text-center mb-2 lh-3 text-11"
                >
                  {{ printSettings.printFooterMessage }}
                </p>

                <p class="text-center text-13 lh-1 mb-1">
                  Organização do evento
                </p>
                <h6 class="text-center mb-0 lh-1">
                  {{ data?.Organization?.name }}
                </h6>

                <p class="text-center mt-4 mb-0 text-10">
                  Ingresso {{ ticket?.sequential }} de {{ ticket?.total }}
                </p>
              </div>
              <div
                style="width: 100%; height: 0.5px; background-color: black"
              ></div>
            </v-card>
          </div>
        </v-theme-provider>
      </section>
    </vue-html2pdf>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import VueHtml2pdf from "vue-html2pdf";
import QrcodeVue from "qrcode.vue";
import paymentUtils from "@/utils/payment";

export default {
  components: { VueHtml2pdf, QrcodeVue },
  data: () => ({
    ticket: null,
    promise: null,
    paymentUtils,
  }),
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  methods: {
    async generatePDF({ ticket }) {
      const promise = new Promise(async (resolve, reject) => {
        try {
          this.ticket = ticket;
          this.promise = { resolve, reject };

          this.$refs.html2Pdf.generatePdf();
        } catch (error) {
          reject(error);
        }
      });
      return promise;
    },
    onProgress(progress) {
      console.log("PDF Progress: ", progress);
    },
    async beforeDownload({ html2pdf, options, pdfContent }) {
      var html2PdfSetup = html2pdf().set(options).from(pdfContent);
      var pdf = await html2PdfSetup.output("blob");
      this.promise.resolve(pdf);
    },
    onError(error) {
      console.log("PDF Error: ", error);
      this.promise.reject(error);
    },
  },
  computed: {
    ...mapGetters("qz", ["settings", "isActive"]),
    printSettings() {
      const { printOptions } = this.ticket || {};
      return {
        printLogo: printOptions?.printLogo ?? false,
        printPlatformLogo: printOptions?.printPlatformLogo ?? false,
        printTitle: printOptions?.printTitle ?? true,
        printSubTitle: printOptions?.printSubTitle ?? false,
        printDateTime: printOptions?.printDateTime ?? true,
        printLocation: printOptions?.printLocation ?? true,
        printQrCode: printOptions?.printQrCode ?? true,
        printLot: printOptions?.printLot ?? true,
        printSector: printOptions?.printSector ?? true,
        printFee: printOptions?.printFee ?? true,
        printPrice: printOptions?.printPrice ?? true,
        printTotalAmount: printOptions?.printTotalAmount ?? false,
        printOwnerBlock: printOptions?.printOwnerBlock ?? false,
        printOwnerName: printOptions?.printOwnerName ?? false,
        printOwnerDocument: printOptions?.printOwnerDocument ?? false,
        printFooterMessage: printOptions?.printFooterMessage ?? false,
      };
    },
  },

  mounted() {
    this.$parent.$on("openExport", this.open);
  },
};
</script>

<style></style>
